import { INCOME_STRUCTURE_BY_KVED_GROUP_SEPARATOR } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/constants.ts';
import type {
  TIncomeStructureByKvedCertificateDto,
  TIncomeStructureByKvedCertificateResponse,
  TIncomeStructureByKvedFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/types.ts';
import {
  createIncomeStructureByKvedIncome,
  formatIncomeStructureByKvedDate,
  getIncomeStructureByKvedDefaultValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/utils.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

const splitEconomicActivityGroup = (value: string) => {
  const [kvedCode = '', ...groupParts] = value.split(INCOME_STRUCTURE_BY_KVED_GROUP_SEPARATOR);

  return groupParts.length
    ? {
        kvedCode: { label: kvedCode, value: kvedCode },
        economicActivityGroup: groupParts.join(INCOME_STRUCTURE_BY_KVED_GROUP_SEPARATOR),
      }
    : { kvedCode: null, economicActivityGroup: value };
};

export const deserializeIncomeStructureByKvedCertificate = (
  certificate: TIncomeStructureByKvedCertificateDto
): TIncomeStructureByKvedFormValues => {
  const defaults = getIncomeStructureByKvedDefaultValues();

  return {
    ...defaults,
    documentDate: formatIncomeStructureByKvedDate(certificate.documentDate) || defaults.documentDate,
    borrowerFullName: certificate.borrowerFullName ?? '',
    borrowerIdentifier: certificate.borrowerIdentifier ?? '',
    soleProprietor: certificate.soleProprietor,
    reportYear: certificate.reportYear ? String(certificate.reportYear) : defaults.reportYear,
    incomes: certificate.incomes?.length
      ? certificate.incomes.map((income) => ({
          ...splitEconomicActivityGroup(income.economicActivityGroup),
          incomeAmount: formatThousandAmount(income.incomeAmount),
        }))
      : [createIncomeStructureByKvedIncome()],
  };
};

export const applyIncomeStructureByKvedGeneralInfo = (
  values: TIncomeStructureByKvedFormValues,
  response: TIncomeStructureByKvedCertificateResponse
): TIncomeStructureByKvedFormValues => ({
  ...values,
  borrowerFullName: response.fullName ?? values.borrowerFullName,
  borrowerIdentifier: response.borrowerEdrpou ?? values.borrowerIdentifier,
  soleProprietor: response.fop,
  reportYear: response.yearPeriod || values.reportYear,
});
